import React, { useState } from "react";
import Header from "../core/Header";
import Footer from "../core/Footer";

import herobridal from '../assets/nifika/hero-bridal.jpg';
import items from "./corsets-items";

const Corsets = () => {

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 27; 

const totalPages = Math.ceil(items.length / itemsPerPage);

const currentItems = items.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

const goToPage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="overflow-x-hidden">

      <section className="relative h-screen  bg-no-repeat bg-cover bg-[center_40%]" style={{ backgroundImage: `url(${herobridal})` }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div> {/* Overlay */}

          {/* Header */}
          <Header />
          
          <div className="relative z-10 h-full flex flex-col justify-center items-center text-white text-center px-4 pt-28">
            <h1 className="text-4xl md:text-4xl lg:text-5xl font-semibold uppercase tracking-wide mb-6">
              Corsets Collection
            </h1>
            <p className="text-lg md:text-xl max-w-3xl leading-relaxed mb-8 ">
            Δημιουργούμε custom-made χειροποίητους κορσέδες που σχεδιάζονται αποκλειστικά για εσάς. Με στόχο να αναδείξουμε κάθε σωματότυπο, δίνουμε έμφαση στην υψηλή αισθητική, χαρίζοντάς σας την τέλεια εφαρμογή για την πιο ξεχωριστή μέρα της ζωής σας
            </p>
        </div>
      </section>

    <section className="p-10 bg-gray-100">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
    {currentItems.map((item, index) => (
        <div
          key={index}
          className="text-center bg-white shadow-md  scale-90"
        >
          <img
            src={item.image}
            alt={item.description}
            className="w-full h-full object-cover"
          />
          <div className="p-4">
            {/* <p className="text-gray-600">{item.description}</p> */}
            <p className="text-gray-600"></p>
          </div>
        </div>
      ))}
    </div>

    <div className="mt-6 flex justify-center space-x-2">
        <button
          className={`px-4 py-2 bg-gray-200 rounded ${
            currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
          }`}
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Προηγούμενη
        </button>

        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={`px-4 py-2 rounded ${
              currentPage === i + 1
                ? "bg-black text-white"
                : "bg-gray-200 text-gray-700"
            }`}
            onClick={() => goToPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className={`px-4 py-2 bg-gray-200 rounded ${
            currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
          }`}
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Επόμενη
        </button>
      </div>

    </section>

    {/* Footer */}
    <Footer />

  </div>
  );
};

export default Corsets;
